import { render, staticRenderFns } from "./PatientHistory.vue?vue&type=template&id=339e76e2&scoped=true&lang=pug"
import script from "./PatientHistory.vue?vue&type=script&lang=js"
export * from "./PatientHistory.vue?vue&type=script&lang=js"
import style0 from "./PatientHistory.vue?vue&type=style&index=0&id=339e76e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339e76e2",
  null
  
)

export default component.exports